import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({
  title = '🎈 泡泡樂園 - 最好玩的免費泡泡點擊遊戲',
  description = '泡泡樂園是一款完全免費、無需下載安裝的線上點擊小遊戲，提供時間挑戰、無盡模式與精準模式三種玩法，點擊可愛泡泡角色快速累積連擊分數，收集金色、時間、爆炸與連擊等特殊道具泡泡，挑戰解鎖25個以上成就，支援手機、平板與電腦瀏覽器直接遊玩，適合各年齡層休閒娛樂。',
  canonical = 'https://bubble.homy.hk/',
  ogImage = 'https://bubble.homy.hk/bubble-icon.svg',
  ogType = 'website'
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />

      {/* Canonical */}
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={ogType} />

      {/* Twitter */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};

export default SEOHead;